import { render, staticRenderFns } from "./MenuWindow.vue?vue&type=template&id=067f7de9"
import script from "./MenuWindow.vue?vue&type=script&lang=js"
export * from "./MenuWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports